























































































































































































































































































































































































import BaseFilter from "@/components/Filter/BaseFilter";
import {Component, PropSync, Watch} from "vue-property-decorator";
import {beginningOfCurrentDay, currentDateEnd, dateFilter} from "@/utils/date-util";
import {Action, Getter} from "vuex-class";
import {DetailFilterParams} from "@/store/call/statistic/types";
import {notifyError, notifyWarning} from "@/utils/notify-helper";
import {MsgTransports, SearchParams} from '@/store/types';
import {getTranslatedParams} from "@/utils/notify-utils";
import {AxiosResponse} from "axios";
import {DatePickerWings,
  FastDateDetailWings,
  SelectWings,
  NumberWings,
  InputWings
} from "wings-ui-components";
import {PartnerItem} from "@/store/settings/partners/types";
import {Originator} from "@/store/settings/originators/types";
import {Account} from "@/store/settings/accounts/types";
import {PartnerUser} from "@/store/user_management/partner_users/types";
import {ServiceProvider} from "@/store/settings/service_providers/types";

@Component({
  components: {
    SelectWings, DatePickerWings, FastDateDetailWings, NumberWings, InputWings
  },
  filters: {dateFilter}
})
export default class CallDetailFilter extends BaseFilter<DetailFilterParams> {
  @PropSync("show") is_show_primary!: boolean;
  @PropSync("showAdditional") is_show_additional!: boolean;
  @PropSync("filterClone") propFilterClone!: DetailFilterParams;
  @PropSync("runFilter") propRunFilter!: boolean;

  @Getter("messageTypes") messageTypesList: any;
  @Getter("callMessagesStatusList") statusList: any;

  @Action("getCallStatisticDetail") actionGetItems: any;
  @Action("exportCallStatisticDetail") actionExport: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getPartnerUsers") actionGetPartnerUsers: any;
  @Action("getOriginators") actionGetOriginators: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("getAccounts") actionGetAccounts: any;
  @Action("getMessageTypes") actionGetMessageTypes: any;
  @Action("actionLog") actionLog: any;

  defaultFilter(): DetailFilterParams {
    return new DetailFilterParams(beginningOfCurrentDay(), currentDateEnd());
  }

  params = {transport: MsgTransports.CALL};
  partnersList: PartnerItem[] = [];
  originatorsList: Originator[] = [];
  accountsList: Account[] = [];
  partnerUsersList: PartnerUser[] = [];
  partnerUsersEmailList: PartnerUser[] = [];
  serviceProvidersList:  ServiceProvider[] = [];

  filterKeys: object = {
    "originator" : "addresser",
    "recipient" : "receiver",
    "broker_account_login" : "account",
    "transport_message_id" : "smpp_message_id",
    "partner_user_login": "partner_login"
  }

  async getPartnersList(filter: SearchParams) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items;
  }

  async getOriginatorsList(filter: SearchParams) {
    const items = await this.actionGetOriginators({...this.params, ...filter});
    this.originatorsList = (filter?.page_number > 1) ? this.originatorsList.concat(items) : items;
  }

  async getAccountsList(filter: SearchParams) {
    const items = await this.actionGetAccounts({...this.params, ...filter});
    this.accountsList = (filter?.page_number > 1) ? this.accountsList.concat(items) : items;
  }

  async getPartnerUsersList(filter: SearchParams) {
    if (this.filter.partner) filter = {...filter, partner: this.filter.partner}
    const items = await this.actionGetPartnerUsers({...this.params, ...filter});
    this.partnerUsersList = (filter?.page_number > 1) ? this.partnerUsersList.concat(items) : items;
  }

  async getPartnerUsersEmailList(filter: SearchParams) {
    if (this.filter.partner) filter = {...filter, partner: this.filter.partner}
    const items = await this.actionGetPartnerUsers({...this.params, ...filter});
    this.partnerUsersEmailList = (filter?.page_number > 1) ? this.partnerUsersEmailList.concat(items) : items;
  }

  async getServiceProvidersList(filter: SearchParams) {
    const items = await this.actionGetServiceProviders({...this.params, ...filter});
    this.serviceProvidersList = (filter?.page_number > 1) ? this.serviceProvidersList.concat(items) : items;
  }

  async created() {
    try {
      await this.actionGetMessageTypes(this.params);
      this.scroll();
    } catch (err) {
      notifyError(err);
    }
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
    if (this.filter.originator) this.originatorsList = await this.actionGetOriginators({originator: this.filter.originator});
    if (this.filter.broker_account_login) this.accountsList = await this.actionGetAccounts({login: this.filter.broker_account_login});
    if (this.filter.partner_user_login) this.partnerUsersList = await this.actionGetPartnerUsers({email: this.filter.partner_user_login});
    if (this.filter.service_provider) this.serviceProvidersList = await this.actionGetServiceProviders({name: this.filter.service_provider});
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Detail statistics",
        addititional_info: getTranslatedParams(this.filter, this.filterKeys)
      }
      const resp = await this.actionGetItems(this.filter);
      await this.actionLog(this.logObject);
      if (resp.status == 204) {
        this.is_last = true
        if (!nextPage) notifyWarning();
      } else {
        this.is_last = false;
      }
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    } finally {
      this.moreLoading = false;
    }
  }

  doActionExport(filter: DetailFilterParams): Promise<AxiosResponse<{ status: string }>> {
    return this.actionExport(filter);
  }

  get is_show(): boolean {
    return this.is_show_primary || this.is_show_additional
  }

  set is_show(value) {
    this.is_show_primary = value;
    this.is_show_additional = value;
  }


  @Watch('is_show_primary')
  onShowPrimaryChanged(val: boolean) {
    if (!val) this.is_show_additional = false;
  }

  @Watch('is_show_additional')
  onShowAdditionalChanged(val: boolean) {
    if (val) this.is_show_primary = true;
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChange(val: DetailFilterParams) {
    this.propFilterClone = val;
  }

  @Watch('runFilter', {immediate: true})
  onRunFilterChange(val: boolean) {
    if (val) {
      this.filtered();
      this.propRunFilter = false;
    }
  }
}
